import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from './Footer';

function CheckResult({ type }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { dominio, fecha } = location.state || {};

  const isSuccess = type === 'success';

  return (
    <div className="result-page">
      <div className="card result-card">
        <div className="card-body">
          <div className={`result-icon ${isSuccess ? 'success-anim' : ''}`} aria-hidden="true">
            {isSuccess ? '✓' : '⚠'}
          </div>
          <span className="sr-only">{isSuccess ? 'Éxito' : 'Atención'}</span>

          <h1 className="result-title" style={{ color: isSuccess ? 'var(--color-success)' : 'var(--color-warning)' }}>
            {isSuccess ? 'Checklist Realizado con Éxito' : 'Habilitado con Condición'}
          </h1>

          <p className="result-subtitle">
            {isSuccess
              ? 'El vehículo ha sido habilitado para su uso.'
              : 'El checklist se guardó con observaciones pendientes.'}
          </p>

          <div className="result-detail">
            <p><strong>Dominio:</strong> {dominio || 'N/A'}</p>
            <p><strong>Fecha y Hora:</strong> {fecha || 'N/A'}</p>
          </div>

          <button className="btn btn-primary btn-full btn-lg" onClick={() => navigate('/')}>
            Realizar otro Checklist
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CheckResult;
